import { useQuery } from 'react-query'
import { request } from '../api/apiCore'

const fetchTrackCodeTypes = () => request({ url: '/admin/track_code_types.json' })
export const useTrackCodeTypesData = () => useQuery('trackCodeTypes', fetchTrackCodeTypes)

const fetchTrackCodeTypeById = id => request({ url: `/admin/track_code_types/${id}.json` })
export const useTrackCodeTypeData = id => useQuery(['trackCodeType', id], () => fetchTrackCodeTypeById(id))
